

import styled from "styled-components"

export const TableHeaderFixedWithCheckboxStyled = styled.div`

    overflow: auto; 
    height: 500px; 

    font: Open Sans;
    font-size: 12px;

    thead th {
        position: sticky; 
        top: 0; z-index: 98; 
    }

    table  { 
        border-collapse: collapse; 
        width: 100%; 
    }
    th, td { 
        /* padding: 8px 16px;  */
    }
    th     { 
        background:#F0F0F0; 
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
    }

    /* Firefox */
    input[type=number] {
    -moz-appearance: textfield;
    }

    .wrapper {
        position: relative;
        overflow: auto;
        border: 1px solid black;
        white-space: nowrap;
    }

    .alert-bg {
      background-color: #F0F0F0;
    }

    .sticky-col {
        position: -webkit-sticky;
        position: sticky;
        background-color: #DCDCDC;
    }

    .checkbox-col-header {
        width: 45px;
        min-width: 45px;
        max-width: 45px;
        left: 0px;
        z-index: 99;
        position: sticky;
        top: 0;
        background-color: #f2f2f2; 
    }

    .checkbox-col {
        overflow-wrap: break-word;
        width: 45px;
        min-width: 45px;
        max-width: 45px;
        left: 0px;
        z-index: 98;
        background-color: #fff;
    }

    .first-col-synthetic {
        overflow-wrap: break-word;
        width: 115px;
        min-width: 115px;
        max-width: 115px;
        left: 45px;
        z-index: 98;
        background-color: #fff;
    }
    
    .second-col-synthetic {
        overflow-wrap: break-word;
        width: 110px;
        min-width: 110px;
        max-width: 110px;
        left: 160px;
        z-index: 98;
        background-color: #fff;
    }
    
    .third-col-synthetic {
        overflow-wrap: break-word;
        width: 110px;
        min-width: 110px;
        max-width: 110px;
        left: 270px;
        z-index: 98;
        background-color: #fff;
    }

    .fourth-col-synthetic {
        overflow-wrap: break-word;
        width: 200px;
        min-width: 200px;
        max-width: 200px;
        left: 380px;
        z-index: 98;
        background-color: #fff;
    }

    .fifth-col-synthetic {
        overflow-wrap: break-word;
        width: 100px;
        min-width: 100px;
        max-width: 100px;
        left: 580px;
        z-index: 98;
        background-color: #fff;
    }

    .first-col-header-synthetic {
        width: 115px;
        min-width: 115px;
        max-width: 115px;
        left: 45px;
        z-index: 99;
        position: sticky;
        top: 0;
        background-color: #f2f2f2; 
    }

    .second-col-header-synthetic {
        width: 110px;
        min-width: 110px;
        max-width: 110px;
        left: 160px;
        z-index: 99;
        position: sticky;
        top: 0;
        background-color: #f2f2f2; 
    }

    .third-col-header-synthetic {
        width: 110px;
        min-width: 110px;
        max-width: 110px;
        left: 270px;
        z-index: 99;
        position: sticky;
        top: 0;
        background-color: #f2f2f2; 
    }

    .fourth-col-header-synthetic {
        width: 200px;
        min-width: 200px;
        max-width: 200px;
        left: 380px;
        z-index: 99;
        position: sticky;
        top: 0;
        background-color: #f2f2f2; 
    }

    .fifth-col-header-synthetic {
        width: 100px;
        min-width: 100px;
        max-width: 100px;
        left: 580px;
        z-index: 99;
        position: sticky;
        top: 0;
        background-color: #f2f2f2; 
    }

    .first-col-analytical {
        overflow-wrap: break-word;
        width: 150px;
        min-width: 150px;
        max-width: 150px;
        left: 45px;
        z-index: 98;
        background-color: #fff;
    }
    
    .second-col-analytical {
        overflow-wrap: break-word;
        width: 100px;
        min-width: 100px;
        max-width: 100px;
        left: 195px;
        z-index: 98;
        background-color: #fff;
    }
    
    .third-col-analytical {
        overflow-wrap: break-word;
        width: 110px;
        min-width: 110px;
        max-width: 110px;
        left: 295px;
        z-index: 98;
        background-color: #fff;
    }

    .fourth-col-analytical {
        overflow-wrap: break-word;
        width: 150px;
        min-width: 150px;
        max-width: 150px;
        left: 405px;
        z-index: 98;
        background-color: #fff;
    }

    .fifth-col-analytical {
        overflow-wrap: break-word;
        width: 200px;
        min-width: 200px;
        max-width: 200px;
        left: 555px;
        z-index: 98;
        background-color: #fff;
    }

    .sixth-col-analytical {
        overflow-wrap: break-word;
        width: 100px;
        min-width: 100px;
        max-width: 100px;
        left: 755px;
        z-index: 98;
        background-color: #fff;
    }

    .seventh-col-analytical {
        overflow-wrap: break-word;
        width: 150px;
        min-width: 150px;
        max-width: 150px;
        left: 855px;
        z-index: 98;
        background-color: #fff;
    }

    .first-col-header-analytical {
        width: 150px;
        min-width: 150px;
        max-width: 150px;
        left: 45px;
        z-index: 99;
        position: sticky;
        top: 0;
        background-color: #f2f2f2; 
    }

    .second-col-header-analytical {
        width: 100px;
        min-width: 100px;
        max-width: 100px;
        left: 195px;
        z-index: 99;
        position: sticky;
        top: 0;
        background-color: #f2f2f2; 
    }

    .third-col-header-analytical {
        width: 110px;
        min-width: 110px;
        max-width: 110px;
        left: 295px;
        z-index: 99;
        position: sticky;
        top: 0;
        background-color: #f2f2f2; 
    }

    .fourth-col-header-analytical {
        width: 150px;
        min-width: 150px;
        max-width: 150px;
        left: 405px;
        z-index: 99;
        position: sticky;
        top: 0;
        background-color: #f2f2f2; 
    }

    .fifth-col-header-analytical {
       width: 200px;
        min-width: 200px;
        max-width: 200px;
        left: 555px;
        z-index: 99;
        position: sticky;
        top: 0;
        background-color: #f2f2f2; 
    }

    .sixth-col-header-analytical {
        width: 100px;
        min-width: 100px;
        max-width: 100px;
        left: 755px;
        z-index: 99;
        position: sticky;
        top: 0;
        background-color: #f2f2f2; 
    }

    .seventh-col-header-analytical {
        width: 150px;
        min-width: 150px;
        max-width: 150px;
        left: 855px;
        z-index: 99;
        position: sticky;
        top: 0;
        background-color: #f2f2f2; 
    }

    .first-col-header-equalization {
        width: 150px;
        min-width: 150px;
        max-width: 150px;
        left: 45px;
        z-index: 99;
        position: sticky;
        top: 0;
        background-color: #f2f2f2; 
    }

    .second-col-header-equalization {
        width: 70px;
        min-width: 70px;
        max-width: 70px;
        left: 195px;
        z-index: 99;
        position: sticky;
        top: 0;
        background-color: #f2f2f2; 
    }

    .third-col-header-equalization {
        width: 150px;
        min-width: 150px;
        max-width: 150px;
        left: 265px;
        z-index: 99;
        position: sticky;
        top: 0;
        background-color: #f2f2f2; 
    }

    .first-col-equalization {
        overflow-wrap: break-word;
        width: 150px;
        min-width: 150px;
        max-width: 150px;
        left: 45px;
        z-index: 98;
        background-color: #fff;
    }
    
    .second-col-equalization {
        overflow-wrap: break-word;
        width: 70px;
        min-width: 70px;
        max-width: 70px;
        left: 195px;
        z-index: 98;
        background-color: #fff;
    }
    
    .third-col-equalization {
        overflow-wrap: break-word;
        width: 150px;
        min-width: 150px;
        max-width: 150px;
        left: 265px;
        z-index: 98;
        background-color: #fff;
    }

`